/**
 * Relative routes are to be used within the router
 * Absolute routes are to be used with the navigate
 */

export const orderRouteAbsolute = '/my-account/email-manager'
